//import 'bootstrap'; // bootstrap.js are called using normal wp style. If you call here jquery and popper.js will be called automacticaly. 

import './scss/main.scss'

console.log('Js loading from child theme!')

// jQuery(document).ready(function ($) {


// });



